<div class="cs-page">
  <app-navbar [backurl]="" [enableBack]="false"></app-navbar>

  <div class="cs-body">
    <mat-spinner *ngIf="!load" [diameter]="40"
      style="--mdc-circular-progress-active-indicator-color:#c9a84c; margin: 80px auto;"></mat-spinner>

    <div class="cs-card" *ngIf="load">
      <div class="cs-icon">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h1 class="cs-title">You're all set!</h1>
      <p class="cs-msg">{{msg}}</p>
      <p class="cs-hint">Redirecting you to your campaigns…</p>
      <a routerLink="/panel/campaigns" class="cs-btn">Go to Campaigns</a>
    </div>
  </div>
</div>
